// istanbul ignore file  # Not needed to test this file
import { createRemoteModule } from '@makemydeal/dr-shared-components';
import type { FunctionComponent } from 'react';

export type FindOrCreateProps = {
    viewportMode: string;
    environment: string;
    dealershipId: string;
    onFindOrCreate: (consumer: any) => void;
    getAuthOverride: () => Promise<string>;
    requiredFields?: string[];
    header: { title: string };
};

export const FindOrCreateModule: FunctionComponent<FindOrCreateProps> = createRemoteModule<FindOrCreateProps>(
    'customer',
    './FindOrCreateModule'
);
